module.exports = __webpack_public_path__ + "img/image 01.5e7956f5.png";